import { render, staticRenderFns } from "./Referral.vue?vue&type=template&id=45c2cff1&scoped=true&"
import script from "./Referral.vue?vue&type=script&lang=ts&"
export * from "./Referral.vue?vue&type=script&lang=ts&"
import style0 from "./Referral.vue?vue&type=style&index=0&id=45c2cff1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2cff1",
  null
  
)

export default component.exports